import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import vehicleClass from "../vehicle/vehicleClass";
import CloseDialogIcon from "../icons/purposed/CloseDialogIcon";

export default function GridVehicleSelectorDialog({
  open,
  onClose,
  onSelect,
  selectedVehicle,
  vehiclesProp,
  time,
}) {
  const [selected, setSelected] = useState(selectedVehicle);
  const [vehicles, setVehicles] = useState(null);

  useEffect(() => {
    setSelected(selectedVehicle);
    // set vehicles as vehicles from vehiclesHook where vehicle.firstDate is null or < time.starttime and vehicle.lastDate os null or > time.starttime
    setVehicles(
      vehiclesProp.filter(
        (vehicle) =>
          (!vehicle.firstDate || vehicle.firstDate < time.starttime) &&
          (!vehicle.lastDate || vehicle.lastDate > time.starttime)
      )
    );
  }, [selectedVehicle]);

  const handleSelect = (vehicle) => {
    setSelected(vehicle);
    onSelect(vehicle);
  };

  if (!vehicles) return null;

  // get vehicleTypeNames without duplicates
  const vehicleTypeNames = vehicles
    .map((vehicle) => vehicle.vehicleTypeName)
    .filter((value, index, self) => self.indexOf(value) === index);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <div className="drag-handle">
          <div className="harmaaTausta">
            <div className="spaceBetween" id="draggable-dialog-title" style={{ cursor: "move" }}>
              <div className="center" style={{ gap: 12 }}>
                <Typography color="primary" variant="h5" align="center" className="fixPrint">
                  Valitse ajoneuvo
                </Typography>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <CloseDialogIcon onClick={onClose} />
              </div>
            </div>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", justifyContent: "space-etween", gap: 6 }}>
          {vehicleTypeNames.map((vehicleTypeName, i) => (
            <div key={i}>
              <div>{vehicleTypeName}</div>
              <List dense>
                {vehicles
                  .filter((vehicle) => vehicle.vehicleTypeName === vehicleTypeName)
                  .map((vehicle) => (
                    <ListItem
                      disablePadding
                      key={vehicle.vehicleId}
                      onClick={() => handleSelect(vehicle)}>
                      <ListItemButton selected={selected?.vehicleId === vehicle.vehicleId}>
                        <ListItemText
                          primary={vehicleClass.vehicleText(vehicle)}
                          secondary={vehicle.vehiclePuomi ? vehicle.vehiclePuomi + "m" : ""}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
              </List>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
GridVehicleSelectorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedVehicle: PropTypes.object,
  vehiclesProp: PropTypes.array.isRequired,
  time: PropTypes.object.isRequired,
};
